module.exports = __webpack_public_path__ + "img/activate.5a92321c.png";